//dependencias
import React, { Component } from 'react';

//componentes
import SeccionesPAction from './seccionesP'

class Index extends Component {

    render(){
        return(
            <div>
                <SeccionesPAction />
            </div>
        );
    }

}
export default Index;